import axios, { AxiosResponse } from 'axios';
import { EditSnapPayload } from './reducer';

export const getSnaps = (page: number): Promise<AxiosResponse> => {
	return axios.get(`/snaps?page=${page}&limit=${5}`);
};

export const addSnap = (capturedInput: string): Promise<AxiosResponse> =>
	axios.post(`/snaps`, { capturedInput });

export const editSnap = (payload: EditSnapPayload): Promise<AxiosResponse> =>
	axios.post(`/snaps/chart-type`, payload);

export const deleteSnap = (id: string): Promise<AxiosResponse> =>
	axios.delete(`/snaps/${id}`);

export const exportSnap = (id: string): Promise<AxiosResponse> =>
	axios.get(`/snaps/csv/${id}`);

export const editSnapDescription = (id: string, name: string, description: string): Promise<AxiosResponse> =>
	axios.post(`/snaps/rename`, { id, name, description });
